import { convertImageFromDto } from "@modules/dtos/imageDto"
import { type CoachDto } from "@modules/profile/coachProfile/coachDto"
import { type HUImage } from "@modules/types/imageTypes"

export class CoachEntity {
  id: string
  username: string
  firstname: string
  lastname: string
  avatar: HUImage | null
  stripeAccountInError: boolean

  private constructor(coach: CoachEntity) {
    this.id = coach.id
    this.username = coach.username
    this.firstname = coach.firstname
    this.lastname = coach.lastname
    this.avatar = coach.avatar
    this.stripeAccountInError = coach.stripeAccountInError
  }

  static fromDto(dto: CoachDto): CoachEntity {
    return new CoachEntity({
      id: dto.id,
      username: dto.username,
      firstname: dto.firstname,
      lastname: dto.lastname,
      avatar: dto.avatar ? convertImageFromDto(dto.avatar) : null,
      stripeAccountInError: dto.stripeAccountInError,
    })
  }
}
